import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { danburyConfig } from "./data";

export default function DanburyPage() {
  return <CityPageTemplate config={danburyConfig} />;
}